export default __webpack_public_path__ + "static/media/coin_tracker_vanillaJS.a9f468db.PNG";